
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as chatSjpnJjI_cjKxsX8bKFqTGyGaK_rHhHmXgJkmKHkm4REMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/chat.vue?macro=true";
import { default as aboutb__S6ouqZJkRuR9jpb6ZvLPWEqYGOfGRFEFboN_45OgWIMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/about.vue?macro=true";
import { default as indexFNaWPWqyq_XGjrut9g8IXNgyrNuhPXsv8IwKoiabSFUMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/index.vue?macro=true";
import { default as contactd1dFq0FgT46T3QmyLq6lNxX4exai9vKk_45JW9VeEIaCEMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/contact.vue?macro=true";
import { default as _91authType_93vii5t4CawjJbpINZh1L5y5y0XKjETl1OedIWXN4F9qwMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/[authType].vue?macro=true";
import { default as indexC_458YxhKCpDg8TOhOQbqOuw1euzX_XgEjUz96OS_ZsyYMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/blog/index.vue?macro=true";
import { default as indexrPTr0lbqYxbD8668mys8G5q7eImHhOJCOTHH0jpCVf0Meta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/help/index.vue?macro=true";
import { default as indexSjOLx5SIlGTACCH0x1OWZLtjFN3JU6JwhzK56ou8_45WkMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/index.vue?macro=true";
import { default as indexEcy4SLSy7lWSp_45OcFlDIExaLfWsczab2GIXtVpiSwuYMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/clubs/index.vue?macro=true";
import { default as _91type_93irHkKV7kZPrd2dKGDiYwBGuOgsMdEc8Oe_45U3rnQKUXAMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/legal/[type].vue?macro=true";
import { default as your_45profileac5qBywuuLDxp11PaRRtuyHLO2wnhktlJB4KxyW7MP0Meta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/your-profile.vue?macro=true";
import { default as _91blogId_93aCwK9r3lrQtUyKnrW78y9FV5EwRonfvWnpU7HGQHjBcMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/blog/[blogId].vue?macro=true";
import { default as indexjkNc0nO2e0HndUKkMENi1AL_Xyl4bdbiVhswsm3qGb4Meta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/roadmap/index.vue?macro=true";
import { default as indexJCQHWWIuq0Q6ONEt0nFoABINOL7LgHNrjZOZTucUroQMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/fixtures/index.vue?macro=true";
import { default as _91howToId_934hD5dayb0e1Yal7mYMK5FQqjJtqhMgtxKP5ta_3aIPUMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/help/[howToId].vue?macro=true";
import { default as categoriesHSk_dukDWc2RsTwBhIzUtEr7JnmCVO2_457uPc4JlbEfoMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/blog/categories.vue?macro=true";
import { default as forgot_45passwordVykYbOvQ7t87k_456AfAhZ1lMwydsKF_KDmYTTzXBchqcMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/forgot-password.vue?macro=true";
import { default as categoriesz_45XtewI_45j2SMMEmDPoXhFrdC7DObhqArk6mzD_oHCFoMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/help/categories.vue?macro=true";
import { default as blogFJStltPWjGZNzdzOscuXo9riRZuAo79gtqcl6CGKuGwMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/super/blog.vue?macro=true";
import { default as _91token_93_45JxYvFHJfOFuk5Un5Dl_45KvC8H1dOG5RdUzzBdQS5LwwMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/validate/[token].vue?macro=true";
import { default as indexZ27yY9U7jxQXeAVDRr3_RjoMGXU0SGpJjtbo4EtMyR0Meta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/super/index.vue?macro=true";
import { default as sportsGDH9qJCvyI0czsb2lDGOgZJyKLYTkECanouCIZwmYvkMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/super/sports.vue?macro=true";
import { default as _91ladderId_93Ae9RMRNACDZbCbfQ56SY1ly5ijqj16uQ3N0yHcAWALsMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/ladders/[ladderId].vue?macro=true";
import { default as index1y_45q1rOLZrmNFe2LpNec9JvJGGf8c2gLquAIHG4GQMcMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/clubs/[clubId]/index.vue?macro=true";
import { default as statslCizg0AoRA91c7pfiGTdlC_45a5_386mYXH7A62LWyeWYMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/clubs/[clubId]/stats.vue?macro=true";
import { default as testimonialsOLm_45_kCNOPOVy81DdktFSqMcOzT325T9np1qPALnhzsMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/super/testimonials.vue?macro=true";
import { default as _91token_937Mcr3HjnPYA_45VOPiCcW3sHBY022Kz_M8FbfxGYn6izsMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/login-with-token/[token].vue?macro=true";
import { default as index_45wp0VRLimxG6dLYl1bXmvPrPoDk5mr27C3tDr2SM6lEMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/players/[playerId]/index.vue?macro=true";
import { default as statsCizoWfCSIg4wfJyrHKCg5Iv0BkiSyDdiwIGF_GAbH0MMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/players/[playerId]/stats.vue?macro=true";
import { default as chatotK8vA1fbtJDK6TT_45H4Y6BxIjIItvTZESGnFWJbnDU0Meta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/chat.vue?macro=true";
import { default as indexXqa_UHAGm4zmNus02QJF6zNB8vIGDAvv5NhNo3aUdusMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/index.vue?macro=true";
import { default as mailerzS7lbjam6MDzo_45U4RidlhDJ0tsClmIdiN_45u1ECzpvj8Meta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/mailer.vue?macro=true";
import { default as membersAHHAyu65bO8_45Y6e4F6m_45Ij5hZCYh8P_455VcbAS_k_45RvwMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/members.vue?macro=true";
import { default as _91_91cycleId_93_938CPPxHKAd3kdRSBKMZhZHNHJsf9JcHOArW64qltX2xAMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/leagues/[leagueId]/[[cycleId]].vue?macro=true";
import { default as indexEmVIcxzXrT5_45YV9vV3AUmS1SEzyecEluqkC8UiAkhRAMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/ladders/index.vue?macro=true";
import { default as indexQiEbyLLkAVnuk0AdMItDtiTvzgFe5rKw7vecj95IQZwMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/leagues/index.vue?macro=true";
import { default as indexZo9yfT36NGd8IhBK52D5rXf5T2yDKBVerpkUEWms2zQMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/scoringSystems/index.vue?macro=true";
import { default as index48JesSXac2EJkuBF8QJuIGaf_gaOxAFYnFvKFnEAFpYMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/leagues/[leagueId]/index.vue?macro=true";
import { default as playersAnwDqN8irJOnb4HikvP_45tyu63qyY8MzIzNS9XBLjGLsMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/ladders/[ladderId]/players.vue?macro=true";
import { default as component_45stubBPFhYYBKbYZQYTIBb6rfC4_45eLnhwjlmC9L6ncY_456aPcMeta } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubBPFhYYBKbYZQYTIBb6rfC4_45eLnhwjlmC9L6ncY_456aPc } from "/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "Chat",
    path: "/chat",
    meta: { ...(chatSjpnJjI_cjKxsX8bKFqTGyGaK_rHhHmXgJkmKHkm4REMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/chat.vue")
  },
  {
    name: "About",
    path: "/about",
    meta: aboutb__S6ouqZJkRuR9jpb6ZvLPWEqYGOfGRFEFboN_45OgWIMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/about.vue")
  },
  {
    name: "Home",
    path: "/",
    meta: indexFNaWPWqyq_XGjrut9g8IXNgyrNuhPXsv8IwKoiabSFUMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/index.vue")
  },
  {
    name: "Contact",
    path: "/contact",
    meta: contactd1dFq0FgT46T3QmyLq6lNxX4exai9vKk_45JW9VeEIaCEMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/contact.vue")
  },
  {
    name: "Login",
    path: "/:authType",
    meta: _91authType_93vii5t4CawjJbpINZh1L5y5y0XKjETl1OedIWXN4F9qwMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/[authType].vue")
  },
  {
    name: "Blog",
    path: "/blog",
    meta: indexC_458YxhKCpDg8TOhOQbqOuw1euzX_XgEjUz96OS_ZsyYMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/blog/index.vue")
  },
  {
    name: "HowItWorks",
    path: "/help",
    meta: indexrPTr0lbqYxbD8668mys8G5q7eImHhOJCOTHH0jpCVf0Meta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/help/index.vue")
  },
  {
    name: "UserDashboard",
    path: "/admin",
    meta: { ...(indexSjOLx5SIlGTACCH0x1OWZLtjFN3JU6JwhzK56ou8_45WkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/index.vue")
  },
  {
    name: "ClubSearch",
    path: "/clubs",
    meta: indexEcy4SLSy7lWSp_45OcFlDIExaLfWsczab2GIXtVpiSwuYMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/clubs/index.vue")
  },
  {
    name: "Terms",
    path: "/legal/:type",
    meta: _91type_93irHkKV7kZPrd2dKGDiYwBGuOgsMdEc8Oe_45U3rnQKUXAMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/legal/[type].vue")
  },
  {
    name: "YourProfile",
    path: "/your-profile",
    meta: { ...(your_45profileac5qBywuuLDxp11PaRRtuyHLO2wnhktlJB4KxyW7MP0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/your-profile.vue")
  },
  {
    name: "BlogView",
    path: "/blog/:blogId",
    meta: _91blogId_93aCwK9r3lrQtUyKnrW78y9FV5EwRonfvWnpU7HGQHjBcMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/blog/[blogId].vue")
  },
  {
    name: "RoadMap",
    path: "/roadmap",
    meta: indexjkNc0nO2e0HndUKkMENi1AL_Xyl4bdbiVhswsm3qGb4Meta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/roadmap/index.vue")
  },
  {
    name: "FixtureSearch",
    path: "/fixtures",
    meta: indexJCQHWWIuq0Q6ONEt0nFoABINOL7LgHNrjZOZTucUroQMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/fixtures/index.vue")
  },
  {
    name: "HowToView",
    path: "/help/:howToId",
    meta: _91howToId_934hD5dayb0e1Yal7mYMK5FQqjJtqhMgtxKP5ta_3aIPUMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/help/[howToId].vue")
  },
  {
    name: "BlogCategories",
    path: "/blog/categories",
    meta: { ...(categoriesHSk_dukDWc2RsTwBhIzUtEr7JnmCVO2_457uPc4JlbEfoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/blog/categories.vue")
  },
  {
    name: "ForgotPassword",
    path: "/forgot-password",
    meta: forgot_45passwordVykYbOvQ7t87k_456AfAhZ1lMwydsKF_KDmYTTzXBchqcMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/forgot-password.vue")
  },
  {
    name: "HowItWorksCategories",
    path: "/help/categories",
    meta: { ...(categoriesz_45XtewI_45j2SMMEmDPoXhFrdC7DObhqArk6mzD_oHCFoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/help/categories.vue")
  },
  {
    name: "SuperBlog",
    path: "/admin/super/blog",
    meta: { ...(blogFJStltPWjGZNzdzOscuXo9riRZuAo79gtqcl6CGKuGwMeta || {}), ...{"middleware":["super"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/super/blog.vue")
  },
  {
    name: "ValidateEmail",
    path: "/validate/:token",
    meta: _91token_93_45JxYvFHJfOFuk5Un5Dl_45KvC8H1dOG5RdUzzBdQS5LwwMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/validate/[token].vue")
  },
  {
    name: "SuperDashboard",
    path: "/admin/super",
    meta: { ...(indexZ27yY9U7jxQXeAVDRr3_RjoMGXU0SGpJjtbo4EtMyR0Meta || {}), ...{"middleware":["super"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/super/index.vue")
  },
  {
    name: "SuperSports",
    path: "/admin/super/sports",
    meta: { ...(sportsGDH9qJCvyI0czsb2lDGOgZJyKLYTkECanouCIZwmYvkMeta || {}), ...{"middleware":["super"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/super/sports.vue")
  },
  {
    name: "LadderDetail",
    path: "/ladders/:ladderId",
    meta: _91ladderId_93Ae9RMRNACDZbCbfQ56SY1ly5ijqj16uQ3N0yHcAWALsMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/ladders/[ladderId].vue")
  },
  {
    name: "ClubDetail",
    path: "/clubs/:clubId",
    meta: index1y_45q1rOLZrmNFe2LpNec9JvJGGf8c2gLquAIHG4GQMcMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/clubs/[clubId]/index.vue")
  },
  {
    name: "ClubStats",
    path: "/clubs/:clubId/stats",
    meta: statslCizg0AoRA91c7pfiGTdlC_45a5_386mYXH7A62LWyeWYMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/clubs/[clubId]/stats.vue")
  },
  {
    name: "SuperTestimonials",
    path: "/admin/super/testimonials",
    meta: { ...(testimonialsOLm_45_kCNOPOVy81DdktFSqMcOzT325T9np1qPALnhzsMeta || {}), ...{"middleware":["super"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/super/testimonials.vue")
  },
  {
    name: "login-with-token-token",
    path: "/login-with-token/:token()",
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/login-with-token/[token].vue")
  },
  {
    name: "PlayerDetail",
    path: "/players/:playerId",
    meta: index_45wp0VRLimxG6dLYl1bXmvPrPoDk5mr27C3tDr2SM6lEMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/players/[playerId]/index.vue")
  },
  {
    name: "PlayerStats",
    path: "/players/:playerId/stats",
    meta: statsCizoWfCSIg4wfJyrHKCg5Iv0BkiSyDdiwIGF_GAbH0MMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/players/[playerId]/stats.vue")
  },
  {
    name: "AdminChat",
    path: "/admin/clubs/:clubId/chat",
    meta: { ...(chatotK8vA1fbtJDK6TT_45H4Y6BxIjIItvTZESGnFWJbnDU0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/chat.vue")
  },
  {
    name: "ClubDashboard",
    path: "/admin/clubs/:clubId",
    meta: { ...(indexXqa_UHAGm4zmNus02QJF6zNB8vIGDAvv5NhNo3aUdusMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/index.vue")
  },
  {
    name: "AdminMailer",
    path: "/admin/clubs/:clubId/mailer",
    meta: { ...(mailerzS7lbjam6MDzo_45U4RidlhDJ0tsClmIdiN_45u1ECzpvj8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/mailer.vue")
  },
  {
    name: "ClubMembers",
    path: "/admin/clubs/:clubId/members",
    meta: { ...(membersAHHAyu65bO8_45Y6e4F6m_45Ij5hZCYh8P_455VcbAS_k_45RvwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/members.vue")
  },
  {
    name: "LeagueDetail",
    path: "/leagues/:leagueId/:cycleId?",
    meta: _91_91cycleId_93_938CPPxHKAd3kdRSBKMZhZHNHJsf9JcHOArW64qltX2xAMeta || {},
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/leagues/[leagueId]/[[cycleId]].vue")
  },
  {
    name: "ClubLadders",
    path: "/admin/clubs/:clubId/ladders",
    meta: { ...(indexEmVIcxzXrT5_45YV9vV3AUmS1SEzyecEluqkC8UiAkhRAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/ladders/index.vue")
  },
  {
    name: "ClubLeagues",
    path: "/admin/clubs/:clubId/leagues",
    meta: { ...(indexQiEbyLLkAVnuk0AdMItDtiTvzgFe5rKw7vecj95IQZwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/leagues/index.vue")
  },
  {
    name: "ClubScoringSystems",
    path: "/admin/clubs/:clubId/scoringSystems",
    meta: { ...(indexZo9yfT36NGd8IhBK52D5rXf5T2yDKBVerpkUEWms2zQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/scoringSystems/index.vue")
  },
  {
    name: "ClubLeagueManage",
    path: "/admin/clubs/:clubId/leagues/:leagueId",
    meta: { ...(index48JesSXac2EJkuBF8QJuIGaf_gaOxAFYnFvKFnEAFpYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/leagues/[leagueId]/index.vue")
  },
  {
    name: "ClubLadderPlayers",
    path: "/admin/clubs/:clubId/ladders/:ladderId/players",
    meta: { ...(playersAnwDqN8irJOnb4HikvP_45tyu63qyY8MzIzNS9XBLjGLsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/TapLeagues.Nuxt/TapLeagues.Nuxt/pages/admin/clubs/[clubId]/ladders/[ladderId]/players.vue")
  },
  {
    name: component_45stubBPFhYYBKbYZQYTIBb6rfC4_45eLnhwjlmC9L6ncY_456aPcMeta?.name,
    path: "/admin/clubs/add",
    component: component_45stubBPFhYYBKbYZQYTIBb6rfC4_45eLnhwjlmC9L6ncY_456aPc
  },
  {
    name: component_45stubBPFhYYBKbYZQYTIBb6rfC4_45eLnhwjlmC9L6ncY_456aPcMeta?.name,
    path: "/how-it-works",
    component: component_45stubBPFhYYBKbYZQYTIBb6rfC4_45eLnhwjlmC9L6ncY_456aPc
  },
  {
    name: component_45stubBPFhYYBKbYZQYTIBb6rfC4_45eLnhwjlmC9L6ncY_456aPcMeta?.name,
    path: "/how-it-works/:pathMatch(.*)",
    component: component_45stubBPFhYYBKbYZQYTIBb6rfC4_45eLnhwjlmC9L6ncY_456aPc
  }
]